export const HOLIDAY_MASTER_LIST = "holiday_list";
export const HOLIDAY_MASTER_LIST_SUCCESSFULL = "holiday_list_successfull";
export const HOLIDAY_DATA_ADD = "holiday_data_add";
export const HOLIDAY_DATA_ADD_SUCCESSFULL = "holiday_data_add_successfull";
export const DELETE_HOLIDAY = "holiday_data_delete";
export const DELETE_HOLIDAY_SUCCESSFULL = "holiday_data_delete_successfull";
export const HOLIDAY_DATA_UPDATE = "holiday_data_update";
export const HOLIDAY_DATA_UPDATE_SUCCESSFULL = "holiday_data_update_successfull";
export const UPDATE_HOLIDAY_LIST_FOR_EMPLOYEES ='update_holiday_list_for_employees';
export const UPDATE_HOLIDAY_LIST_FOR_EMPLOYEES_SUCCESSFULL ='update_holiday_list_for_employees_successfull';